import { Maybe, StateAssert } from '@csp/csp-common-model';
import { Timing } from '../../model/schedulingModels/Timing';
import { Duration } from '../../model/schedulingModels/Duration';

export const getTimingRepeatPeriod = (timing: Timing): Maybe<Duration> => {
  if (timing.repeat?.period) {
    StateAssert.notNull(timing.repeat?.periodUnit, 'When repeat.period is used, repeat.periodUnit is mandatory');
    return {
      value: timing.repeat?.period,
      unit: timing.repeat?.periodUnit,
    };
  } else {
    return undefined;
  }
};
